// extracted by mini-css-extract-plugin
export default {"boneStepImageContainer":"BoneStepImage_boneStepImageContainer__3hCeE","clickable":"BoneStepImage_clickable__mVuRo"};